import { guideCalloutHtml } from "../../elements/callout/component.js";
import { validate } from "../../helpers/validate.js";
import { attributesCalloutSchema } from "./attributes.js";
import { CalloutType } from "./attributes.js";
import { calloutIconNameFromType, ScalarCalloutVue } from "./component.js";
const scalarCallout = {
  name: "scalar-callout",
  tagName: "scalar-callout",
  tiptapName: "callout",
  attributeTransform: (_, attrs) => {
    return validate(attributesCalloutSchema, {
      ...attrs,
      icon: typeof attrs.icon === "string" ? attrs.icon : typeof attrs.icon?.src === "string" ? attrs.icon?.src : "",
      // Handle legacy `calloutType` attribute
      type: attrs.type || attrs.calloutType || "neutral"
    });
  },
  render: async (props) => {
    const transformed = scalarCallout.attributeTransform("", props);
    return transformed ? guideCalloutHtml(transformed) : "";
  }
};
export {
  CalloutType,
  ScalarCalloutVue,
  calloutIconNameFromType,
  scalarCallout
};
//# sourceMappingURL=index.js.map
